// @ts-nocheck
/* Apparel multi-buy tiers.

   Clicking a tier sets the product form's quantity input, so the existing add-to-cart form
   submits qty 1, 2 or 3 of the currently selected variant. No product switching and no price
   maths here: Liquid renders every tier's formatted total and this only moves the
   pre-formatted string onto the button.

   The discount itself is a Shopify automatic discount applied at cart, so the tier prices
   shown are a display of that ladder, not the line price.

   Listeners are delegated on document rather than bound per card. A variant change morphs the
   buy box and REPLACES this block's root, which silently killed per-element listeners and left
   the tiers unclickable after any size change.

   sb-pricing.js also writes the Add to Bag price, so for a tier above 1 the total is written
   and then defended with a MutationObserver until the shopper returns to tier 1. */
(function () {
  'use strict';

  if (window.__tdApparelMultibuy) return;
  window.__tdApparelMultibuy = true;

  function scopeOf(el) {
    return (
      el.closest('.product-details-column') ||
      el.closest('.product-information__wrapper') ||
      el.closest('.pdp-v2') ||
      document
    );
  }

  function formOf(el) {
    var scope = scopeOf(el);
    return (
      scope.querySelector('.buy-buttons-block form[data-type="add-to-cart-form"]') ||
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      scope.querySelector('.buy-buttons-block form') ||
      scope.querySelector('form')
    );
  }

  function applyQty(el, qty) {
    var form = formOf(el);
    var input = form && form.querySelector('input[name="quantity"]');
    if (!input || !(qty > 0)) return;
    if (input.value === String(qty)) return;
    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---- Add to Bag total ------------------------------------------------ */

  function eachPriceEl(cb) {
    document.querySelectorAll('.add-to-cart-text__content').forEach(function (content) {
      var wrap = content.querySelector('.custom-atc-price-wrap');
      if (!wrap) {
        wrap = document.createElement('span');
        wrap.className = 'custom-atc-price-wrap';
        wrap.style.cssText = 'display:inline-flex;align-items:center;gap:4px;margin-left:6px;';
        wrap.innerHTML =
          '<span class="custom-atc-strike-price" style="text-decoration:line-through;margin-right:4px;display:none;"></span>' +
          '<span class="atc-price"></span>';
        content.appendChild(document.createTextNode(' '));
        content.appendChild(wrap);
      }
      cb(wrap.querySelector('.atc-price'), wrap.querySelector('.custom-atc-strike-price'));
    });
  }

  function writeTotal(text) {
    eachPriceEl(function (priceEl, strikeEl) {
      if (priceEl && priceEl.textContent !== text) priceEl.textContent = text;
      if (strikeEl) {
        strikeEl.textContent = '';
        strikeEl.style.display = 'none';
      }
    });
  }

  var desired = '';
  var enforcing = false;
  var observer = null;

  function startEnforce(text) {
    desired = text;
    enforcing = true;
    if (!observer) {
      observer = new MutationObserver(function () {
        if (!enforcing || !desired) return;
        var mismatch = false;
        document.querySelectorAll('.add-to-cart-text__content .atc-price').forEach(function (el) {
          if (el.textContent !== desired) mismatch = true;
        });
        if (mismatch) writeTotal(desired);
      });
    }
    writeTotal(text);
    document.querySelectorAll('.add-to-cart-text__content').forEach(function (c) {
      observer.observe(c, { subtree: true, childList: true, characterData: true });
    });
  }

  function stopEnforce() {
    enforcing = false;
    desired = '';
    if (observer) observer.disconnect();
  }

  /* ---- Selection ------------------------------------------------------- */

  function select(card) {
    var root = card.closest('.td-mbuy');
    if (!root) return;

    root.querySelectorAll('.td-mbuy__card').forEach(function (c) {
      var on = c === card;
      c.classList.toggle('td-mbuy__card--selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
      var input = c.querySelector('.td-mbuy__input');
      if (input) input.checked = on;
    });

    var qty = parseInt(card.dataset.qty, 10) || 1;
    applyQty(root, qty);

    var total = card.dataset.totalFormatted || '';
    if (qty > 1 && total) startEnforce(total);
    else stopEnforce();
  }

  // Re-apply whatever the freshly rendered markup says is selected. After a morph the block
  // comes back on tier 1, so the form's quantity has to follow it back down. A sold-out size
  // renders no tiers at all, and the quantity left behind by the previous size has to come
  // back down with them or the pre-order form posts 2 or 3.
  function syncFromDom() {
    var roots = document.querySelectorAll('.td-mbuy');

    if (!roots.length) {
      var form = document.querySelector('.product-details-column') || document;
      var input = form.querySelector('form input[name="quantity"]');
      if (input && input.value !== '1') {
        input.value = 1;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      stopEnforce();
      return;
    }

    roots.forEach(function (root) {
      var card = root.querySelector('.td-mbuy__card--selected') || root.querySelector('.td-mbuy__card');
      if (card) select(card);
    });
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.td-mbuy__card');
    if (card) select(card);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Enter') return;
    var card = event.target.closest('.td-mbuy__card');
    if (!card) return;
    event.preventDefault();
    select(card);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromDom);
  } else {
    syncFromDom();
  }

  document.addEventListener('shopify:section:load', function () {
    stopEnforce();
    syncFromDom();
  });

  // The variant morph replaces this block wholesale and fires no section:load
  document.addEventListener('variant:update', function () {
    stopEnforce();
    setTimeout(syncFromDom, 0);
  });
})();
